module.exports = __webpack_public_path__ + "img/cos.7bed5e6a.svg";